/**
 * Phrases Data Interface and Categories
 * 短语数据接口和分类定义
 */

export interface Phrase {
  id: string;
  phrase: string; // Phrase itself
  phonetic?: string; // IPA phonetic notation (通用音标)
  phoneticUS?: string; // American English phonetic
  phoneticUK?: string; // British English phonetic
  meaning: string; // Chinese meaning
  usageScenario?: string; // Usage scenario description
  example: string; // Example sentence
  exampleTranslation?: string; // Example translation
  category: string; // Category
  difficulty?: 'easy' | 'medium' | 'hard';
  grade?: '3' | '4' | '5' | '6' | '7' | '8' | '9'; // Applicable grade
  level?: 'elementary' | 'middle'; // School level
  frequency?: 'high' | 'medium' | 'low'; // Usage frequency
}

export const phraseCategories = [
  // Greetings and Politeness (问候与礼貌)
  { id: 'greetings', name: '问候语', icon: '👋', level: 'elementary' },
  { id: 'politeness', name: '礼貌用语', icon: '🙏', level: 'elementary' },

  // Daily Life (日常生活)
  { id: 'daily_expressions', name: '日常表达', icon: '💬', level: 'elementary' },
  { id: 'time_place', name: '时间地点', icon: '🕐', level: 'elementary' },
  { id: 'actions', name: '动作短语', icon: '🏃', level: 'elementary' },

  // Communication (交流)
  { id: 'asking', name: '询问表达', icon: '❓', level: 'elementary' },
  { id: 'requests', name: '请求表达', icon: '🤝', level: 'elementary' },
  { id: 'responses', name: '回应表达', icon: '✅', level: 'elementary' },

  // Feelings and Opinions (情感观点)
  { id: 'feelings', name: '情感表达', icon: '😊', level: 'elementary' },
  { id: 'opinions', name: '观点表达', icon: '💭', level: 'middle' },

  // Middle School Level (初中)
  { id: 'academic', name: '学习表达', icon: '📚', level: 'middle' },
  { id: 'social', name: '社交表达', icon: '👥', level: 'middle' },
];
